import axios from 'axios';

const RESSOURCE_NAME = 'documents';

export default {
    uploadDocument(id, data, config) {
        // var personnes = Object.fromEntries(data.personnes)
        return axios.post(`${RESSOURCE_NAME}/upload/` + id, data, config)
    },

    uploadProjectDocuments(id_projet, data) {
        return axios.post(`${RESSOURCE_NAME}/projet/${id_projet}/documents/`, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        })
    },

    uploadTemp(document) {
        const formData = new FormData();
        formData.append('document', document);

        return axios.post(`${RESSOURCE_NAME}/uploadTemp`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
    },

    uploadTempDocument(id, data, config) {
        // var personnes = Object.fromEntries(data.personnes)
        return axios.post(`${RESSOURCE_NAME}/upload/` + id, data, config)
    },

    deleteDocument(id) {
        // var personnes = Object.fromEntries(data.personnes)
        return axios.delete(`${RESSOURCE_NAME}/delete/` + id)
    },

    deleteProjectDocument(project_id, data) {
        return axios.post(`${RESSOURCE_NAME}/projet/${project_id}/documents/delete`, data)
    },

    createDirectory(data) {
        return axios.post(`${RESSOURCE_NAME}/directories/create`, data);
    },

    uploadFile(data, id, config) {
        return axios.post(`${RESSOURCE_NAME}/upload/entreprise/` + id, data, config);
    },
    downloadDocuments(id) {
        return axios.get(`${RESSOURCE_NAME}/download/` + id, { responseType: 'arraybuffer' })
    },
    getProjectDocuments(project_id) {
        return axios.get(`${RESSOURCE_NAME}/projet/${project_id}`);
    },
    getBase64File(id) {
        return axios.get(`${RESSOURCE_NAME}/base64/${id}`);
    },
    deleteDirectory(id, data) {
        return axios.post(`${RESSOURCE_NAME}/delete/directory/${id}`, data);
    },
};
